import React from 'react';
import { Route } from 'react-router-dom'
import './index.css';

const Header = () => {
    return (
        <Route render={({ history }) => (
            <div id="Logo" onClick={() => { history.push('/') }}>
                <div className="logoImg"></div>
                <div className="titleContainer">
                    <strong className="title">TRICARD</strong>
                    <span className="subtitle">postcard sharing</span>
                </div>
            </div>
        )} />
    )
}

export default Header;